import { ISpecializedCombo, useCombo } from "@hooks/useCombo";
import useFormatter from "@hooks/useFormatter";
import MenuItem from "@material-ui/core/MenuItem";
import { useClienteService } from "@services/ClienteService";
import React from "react";

export interface IRemetenteWhatsapp {
    remetenteWhatsappId: number,
    numero: string,
    descricao: string,
    ativo: string
}

export type IComboRemetenteWhatsapp = ISpecializedCombo<IRemetenteWhatsapp> & {
    createOptionsWithNumero: () => JSX.Element[]
}

export function useRemetenteWhatsappCombo (initialValue?: number) : IComboRemetenteWhatsapp {
    const combo = useCombo<IRemetenteWhatsapp>({
        value: initialValue
    });

    const formatter = useFormatter();
    const clienteService = useClienteService();

    const createOptions = React.useCallback(() => {
        return combo.set.map((remetenteWhatsapp, index) => {
            return <MenuItem key={index} value={remetenteWhatsapp.remetenteWhatsappId}>{ remetenteWhatsapp.numero }</MenuItem>
        });
    }, [combo.set]);

    const createOptionsWithNumero = React.useCallback(() => {
        return combo.set.map((remetenteWhatsapp, index) => {
            return <MenuItem key={index} value={remetenteWhatsapp.numero}>{formatter.toCelular(remetenteWhatsapp.numero)}</MenuItem>
        });
    }, [combo.set, formatter]);

    const loadOptions = React.useCallback(() => {
        combo.load(clienteService.listarRemetentesWhatsappAtivos)
    }, [combo, clienteService.listarRemetentesWhatsappAtivos]);

    return React.useMemo(() => ({
        ...combo, createOptions, loadOptions, createOptionsWithNumero
    }), [combo, createOptions, loadOptions, createOptionsWithNumero]);
}